import React from 'react';

const Sidebar = ({ tabs, activeTab, onTabChange, loading, tabsData, totalDocuments = 0, viewedTabs = new Set() }) => {
  const formatTabName = (tabKey) => {
    // Convert snake_case or camelCase to Title Case without double spaces
    return tabKey
      .replace(/([a-z])([A-Z])/g, '$1 $2') // Only add space between lowercase and uppercase
      .replace(/[_-]/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase())
      .trim();
  };

  if (tabs.length === 0 && !loading) {
    return (
      <div className="sidebar">
        <div className="sidebar-content">
          <div className="content-empty-box" style={{ marginTop: '32px' }}>
            <svg style={{ width: '48px', height: '48px', margin: '0 auto 16px', color: '#d1d5db' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <p style={{ fontSize: '0.875rem' }}>Search for a Lead ID to view documents</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <h3>Documents</h3>
        <nav className="sidebar-nav">
          {tabs.map((tabKey) => {
            console.log('Tab key:', tabKey); // Debug: log tab keys
            const isActive = activeTab === tabKey;
            const tabStatus = tabsData?.[tabKey];
            const isNoData = tabStatus === "NO_DATA";
            const isFailure = tabStatus === "FAILURE";
            const isNotApplicable = tabStatus === "NOT_APPLICABLE";
            const isDisabled = isNoData || isFailure || isNotApplicable;
            const isUnread = !viewedTabs.has(tabKey) && !isActive && !isDisabled;
            
            return (
              <button
                key={tabKey}
                onClick={() => !isDisabled && onTabChange(tabKey)}
                className={`sidebar-tab ${isActive ? 'active' : ''} ${isDisabled ? 'disabled' : ''} ${isNoData ? 'no-data' : ''}`}
                disabled={isDisabled}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <div className="sidebar-tab-indicator"></div>
                  {formatTabName(tabKey)}
                </div>
                
                {/* Right-side badges container - keeps alignment consistent across all tabs */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
                  {/* Status badges */}
                  {isNoData && (
                    <span style={{
                      fontSize: '0.7rem',
                      color: '#f59e0b',
                      backgroundColor: '#fef3c7',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontWeight: '500'
                    }}>No Data</span>
                  )}
                  
                  {isFailure && (
                    <span style={{
                      fontSize: '0.7rem',
                      color: '#dc2626',
                      backgroundColor: '#fee2e2',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontWeight: '500'
                    }}>Error</span>
                  )}
                  
                  {isNotApplicable && (
                    <span style={{
                      fontSize: '0.7rem',
                      color: '#6b7280',
                      backgroundColor: '#f3f4f6',
                      padding: '2px 6px',
                      borderRadius: '4px',
                      fontWeight: '500'
                    }}>N/A</span>
                  )}
                  
                  {/* New badge for Model Results and Triggers tabs */}
                  {(tabKey === 'Model Results' || tabKey === 'model_tab' || tabKey === 'Triggers' || tabKey === 'Trigger Tab' || tabKey === 'trigger_tab') && (
                    <span style={{
                      fontSize: '0.7rem',
                      color: '#fff',
                      backgroundColor: '#10b981',
                      padding: '3px 8px',
                      borderRadius: '4px',
                      fontWeight: '700',
                      boxShadow: '0 2px 4px rgba(16, 185, 129, 0.3)',
                      border: '1px solid #059669',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      lineHeight: '1.2',
                      whiteSpace: 'nowrap'
                    }}>
                      NEW
                    </span>
                  )}
                  
                  {/* Unread indicator - pulsing blue dot (only for successful tabs) */}
                  {isUnread && (
                    <span style={{
                      width: '8px',
                      height: '8px',
                      backgroundColor: '#3b82f6',
                      borderRadius: '50%',
                      flexShrink: 0,
                      animation: 'pulse-dot 2s ease-in-out infinite'
                    }}></span>
                  )}
                </div>
              </button>
            );
          })}
          
          {/* Loading indicator below tabs with count */}
          {loading && totalDocuments > 0 && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 16px',
              color: '#6b7280',
              fontSize: '0.875rem',
              marginTop: '8px'
            }}>
              <div style={{
                width: '16px',
                height: '16px',
                border: '2px solid #e5e7eb',
                borderTop: '2px solid #8B5E3C',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite'
              }}></div>
              <span>
                Loading {totalDocuments - tabs.length} more document{totalDocuments - tabs.length !== 1 ? 's' : ''}...
              </span>
            </div>
          )}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
